var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "response-details-wrapper" },
    _vm._l(_vm.details, function (detailSet, detailSetKey, detailSetIndex) {
      return _c(
        "div",
        { key: "details-" + detailSetIndex, staticClass: "row mb-2" },
        [
          _c("div", { staticClass: "col-12" }, [
            _c(
              "h4",
              { staticClass: "bold mb-2 d-flex", attrs: { id: detailSetKey } },
              [
                detailSetIndex === 0 && !_vm.externalTab
                  ? _c("span", { on: { click: _vm.goBack } }, [
                      _c(
                        "i",
                        {
                          staticClass:
                            "material-icons text-primary clickable mr-1",
                        },
                        [_vm._v("arrow_back")]
                      ),
                    ])
                  : _vm._e(),
                _vm._v(
                  "\n        " +
                    _vm._s(_vm.getSectionTitle(detailSetKey)) +
                    "\n\n        "
                ),
                detailSetIndex === 0 && !_vm.externalTab
                  ? _c("icon", {
                      staticClass: "ml-auto",
                      attrs: { name: "external-link" },
                      on: { click: _vm.requestSubmitConfirmation },
                    })
                  : _vm._e(),
              ],
              1
            ),
          ]),
          _vm._v(" "),
          detailSetKey === "responseNotes"
            ? _c(
                "ul",
                { staticClass: "col-12 bullet" },
                _vm._l(detailSet, function (info, infoKey, infoIndex) {
                  return _c(
                    "li",
                    { key: "details-set-" + infoIndex, staticClass: "ml-3" },
                    [
                      _vm._v(
                        "\n        " +
                          _vm._s(_vm._f("capitalize")(info)) +
                          "\n      "
                      ),
                    ]
                  )
                }),
                0
              )
            : _vm._l(detailSet, function (info, infoKey, infoIndex) {
                return _c(
                  "div",
                  {
                    key: "details-set-" + infoIndex,
                    staticClass: "col-4 mt-1",
                  },
                  [
                    _c("p", { staticClass: "mb-0" }, [
                      _c("span", { staticClass: "bold" }, [
                        _vm._v(_vm._s(_vm.getSectionTitle(infoKey)) + ": "),
                      ]),
                      _vm._v(" "),
                      _c("span", { staticClass: "capitalize" }, [
                        _vm._v(_vm._s(info)),
                      ]),
                    ]),
                  ]
                )
              }),
        ],
        2
      )
    }),
    0
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }